import React from "react"
import { Badge } from "reactstrap"
import check from "assets/icons/check-circle-full.svg"
import slash from "assets/icons/slash-circle-full.svg"

function StatusBadge({ children, variant }) {
  const icon = variant == "success" ? check : slash

  return (
    <div className="d-flex">
      <Badge
        color={variant}
        pill
        className="outline d-flex align-items-center gap-1"
      >
        <img src={icon} />
        <span className="text-gray-800">{children}</span>
      </Badge>
    </div>
  )
}

export default StatusBadge
